'use strict';

import type { UserFlag } from '@api/Entities/User/UserFlag';
import { EntityCollection } from '../EntityCollection';

export class UserFlagCollection extends EntityCollection<UserFlag> {}
